import { FC } from 'react';
import { Link, useNavigate } from 'react-router-dom';

// COMPONENTS
import ImgRem from '../../../libs/imgRem';

// PACKAGES
import { Container } from 'react-bootstrap';
import { useAppDispatch, useAppSelector } from '../../../store/slice';
import { getUserDomain } from '../../../libs/utils';
import { UserSlice } from '../../../store/slice/User';

const TrialEnded: FC = () => {
	const dispatch = useAppDispatch();
	const navigate = useNavigate();
	const user = useAppSelector((state) => state.user);

	return (
		<>
			<picture>
				<source srcSet="./img/login-bg.webp" />
				<img
					src="./img/login-bg.jpg"
					className="position-fixed w-100 h-100 object-fit object-fit-cover user-select-none"
					alt="Tiled books background"
				/>
			</picture>
			<main className="page-staff-login d-flex align-items-center py-5">
				<Container className="position-relative z-1">
					<div className="form-rounded-corners">
						<ImgRem
							src="/svg/llll-online-contained-wide-logo.svg"
							width="231"
							height="70"
							alt="Little Learners Love Literacy Online logo"
							className="logo mx-auto"
						/>
						<h2 className="text-shades-800 m-0">
							<strong>Your trial has ended</strong>
						</h2>
						<div>
							<p>We hoped you enjoyed your trial of the Little Learners Online platform.</p>
							<p className="m-0">
								To keep using the Little Learners Online platform with your school, please choose from one of our
								subscription options today.
							</p>
						</div>
						<div className="d-grid gap-3">
							<Link to={`${getUserDomain('buyer')}?trialId=${user.activeOrganisationId}`} className="btn btn-lg">
								View subscription options
							</Link>
							<button
								type="button"
								className="btn btn-lg btn-white"
								onClick={() => {
									dispatch(UserSlice.actions.logOut());
									navigate('/login');
								}}
							>
								Log out
							</button>
						</div>
					</div>
				</Container>
			</main>
		</>
	);
};

export default TrialEnded;
